export const getLocalStorage = <T>(key: string): T | undefined => {
    const item = localStorage.getItem(key);
    if (!item) return undefined;
    
    try {
        return JSON.parse(item) as T;
    } catch (e) {
        // If parsing fails, return the raw string as T
        return item as unknown as T;
    }
};

export const addLocalStorage = <T>(key: string, value: T): void => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const deleteLocalStorage = (key: string): void => {
    localStorage.removeItem(key);
};
